module.exports = __webpack_public_path__ + "img/manage_booking.ca218019.svg";